import React from 'react'
import Style from '../mappingUi.module.css'
export const LoadingState = ({ message }) => (
    <div className={Style.stateBlock}>
        <span className={Style.inlineSpinner} aria-hidden="true" />
        <p className={Style.stateText}>{message}</p>
    </div>
)
export const ErrorState = ({ message }) => (
    <div className={Style.stateBlock}>
        <i className={`uil-exclamation-octagon ${Style.stateIconError}`} aria-hidden="true" />
        <p className={Style.stateText}>{message}</p>
    </div>
)
export const EmptyState = ({ icon, message, hint }) => (
    <div className={Style.stateBlock}>
        <i className={`${icon} ${Style.stateIcon}`} aria-hidden="true" />
        <p className={Style.stateText}>{message}</p>
        {hint ? <p className={Style.stateHint}>{hint}</p> : null}
    </div>
)
